// Mantine
import { Anchor, RingProgress, Button } from '@mantine/core'

// Dayjs
import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/fr'
dayjs.extend(LocalizedFormat)
dayjs.locale('fr')

// Next
import RouterLink from '@/components/ui/RouterLink'

// UI
import Box from '../ui/Box'
import ProductionOrderSmallDisplay from '../production_orders/ProductionOrderSmallDisplay'

export default function ComponentProductionOrders({ component }) {
    return (
        <Box title="Assemblages" subtitle="Programmés ou en cours">
            {component.production_orders.length === 0 && (
                <div className="text-gray-500 text-sm text-center">
                    Aucun assemblage associés.
                </div>
            )}

            <div className="flex flex-col gap-2">
                {[...component.production_orders]
                    .sort((a, b) => new Date(a.starting_at) - new Date(b.starting_at))
                    .map((production_order) => {
                    // Calculate the percentage of the quantity in control
                    const quantityInControlPercentage =
                        (production_order.quantity_in_control /
                            production_order.quantity) *
                        100

                    // Calculate the percentage of the quantity completed
                    const quantityCompletedPercentage =
                        (production_order.quantity_completed /
                            production_order.quantity) *
                        100

                    // Get verbose ending_at date
                    const endingAt = dayjs(production_order.ending_at).format(
                        'dddd D MMMM YYYY'
                    )

                    return (
                        <ProductionOrderSmallDisplay
                            production_order={production_order}
                            key={production_order.id}
                        />
                    )

                    return (
                        <div
                            className="grid grid-cols-[1fr_200px_100px] items-center"
                            key={production_order.id}
                        >
                            <div className="flex flex-col items-start">
                                <Anchor>
                                    <a
                                        href={
                                            '/assembly/' + production_order.id
                                        }
                                    >
                                        A{production_order.id} -{' '}
                                        {production_order.quantity} montres
                                    </a>
                                </Anchor>

                                <span className="text-sm text-gray-400">
                                    Sera terminé le {endingAt}
                                </span>
                            </div>

                            <span className="text-sm text-gray-400">
                                {production_order.location.name}
                            </span>

                            <div className="flex items-center justify-end gap-3">
                                <span className="text-gray-500 text-xs">
                                    {production_order.quantity_completed +
                                        ' / ' +
                                        production_order.quantity}
                                </span>

                                <RingProgress
                                    size={40}
                                    thickness={12}
                                    sections={[
                                        {
                                            value: quantityCompletedPercentage,
                                            color: 'green',
                                            tooltip:
                                                'Terminé : ' +
                                                production_order.quantity_completed +
                                                ' / ' +
                                                production_order.quantity,
                                        },
                                        {
                                            value: quantityInControlPercentage,
                                            color: 'orange',
                                            tooltip:
                                                'En contrôle qualité : ' +
                                                production_order.quantity_in_control +
                                                ' / ' +
                                                production_order.quantity,
                                        },
                                    ]}
                                />
                            </div>
                        </div>
                    )
                })}
            </div>

            <div className="mt-5 flex justify-center">
                <Button
                    component={RouterLink}
                    href={`/assembly/create?component_id=${component.id}`}
                    variant="default"
                >
                    Programmer un assemblage
                </Button>
            </div>
        </Box>
    )
}
